import axios from 'axios';
import * as apiConstant from './apiConstant';

/****************************************
    Api for Language
    @author  IMH003
    @date    2020.5.10
    @version 0.1    
 ******************************************/
class langApi {
    static getLangTypes(lang_key) {    
        return axios({
            url: `${apiConstant.API_URL}/langtype/${lang_key}`,
            method: 'GET',
            headers: {
                'accept': 'application/json'
            }
        })
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error;
        });
    }
}

export default langApi;

